import Box from '@mui/material/Box';
import CDatePicker from 'crqlar-react-common/dist/components/CDatePicker';

interface NodeDateTimeFieldProps {
    label: string;
    /** Undefined leaves the field empty; its × hands back undefined. */
    value: Date | undefined;
    onChange: (value: Date | undefined) => void;
    disabled?: boolean;
}

const NodeDateTimeField = ({label, value, onChange, disabled}: NodeDateTimeFieldProps) => (
    <Box sx={{'& .MuiFormControl-root': {m: 0, width: '100%'}}}>
        <CDatePicker
            label={label}
            value={value}
            onChange={onChange}
            disabled={disabled}
            size={'small'}
        />
    </Box>
);

export default NodeDateTimeField;
